import { gql } from '@apollo/client';

export const getVignetteIntroCollection = gql`
	query getVignetteIntroCollection($lang: String, $id: String) {
		vignetteIntroCollection(locale: $lang, where: { landEnum: { landList_contains: $id } }) {
			items {
				title(locale: $lang)
				headline(locale: $lang)
				text(locale: $lang) {
					json
				}
				infoLinkText(locale: $lang)
				infoLinkUrl
			}
		}
	}
`;
